export default __webpack_public_path__ + "static/media/locIcon.aff5d9e4.svg";